import Banner from '@blocks/Banner';
import Cta from '@blocks/Cta';
import CtaForm from '@blocks/CtaForm';
import List from '@blocks/List';
import Navigation from '@blocks/Navigation';
import ResultsBanner from '@blocks/ResultsBanner';
import ResultsPillar from '@blocks/ResultsPillar';
import ResultsYourResults from '@blocks/ResultsYourResults';
import Survey from '@blocks/Survey';
import TwoColumn from '@blocks/TwoColumn';
import Typography from '@blocks/Typography';
import useQuestionnaireStore from '@store/questionnaire';
import React, { useEffect, useState } from 'react';
import { decodeSurvey } from 'utilities/api';
import { hash } from 'utilities/helper';
import { queryScoresToJson } from 'utilities/scores';

import data from './data/data';
import { Content } from './data/types';
import useStore from './store/store';

interface PointerHandlerEventType {
  clientX: number;
  clientY: number;
}

function pointerhandler(event: PointerHandlerEventType) {
  const { clientX, clientY } = event;
  document.documentElement.style.setProperty('--cursor-x', clientX.toString());
  document.documentElement.style.setProperty('--cursor-y', clientY.toString());
}

const App: React.FC = () => {
  const { page, setPage } = useStore();
  const { setDisplayEndResultsStore, setPillarsStore } =
    useQuestionnaireStore();

  const [content, setContent] = useState<Content[]>([]);

  useEffect(() => {
    const queryString = window.location.search;

    const params = new URLSearchParams(queryString);

    const paramsObject: { [key: string]: string } = {};
    params.forEach((value, key) => {
      paramsObject[key] = value;
    });

    const scoreJson = queryScoresToJson(queryString);

    try {
      // Check for a known key accross all six pillars
      if (
        Object.prototype.hasOwnProperty.call(
          paramsObject,
          'pillar01.question1'
        ) &&
        Object.prototype.hasOwnProperty.call(
          paramsObject,
          'pillar02.question1'
        ) &&
        Object.prototype.hasOwnProperty.call(
          paramsObject,
          'pillar03.question1.question1'
        ) &&
        Object.prototype.hasOwnProperty.call(
          paramsObject,
          'pillar04.question1.question1'
        ) &&
        Object.prototype.hasOwnProperty.call(
          paramsObject,
          'pillar05.question1.chatbots'
        ) &&
        Object.prototype.hasOwnProperty.call(paramsObject, 'pillar06.question1')
      ) {
        setPillarsStore(decodeSurvey(scoreJson));
        setDisplayEndResultsStore(true);
        setPage('results');
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    setContent(page !== null ? data[page]?.content : []);

    document.addEventListener('pointerdown', pointerhandler);
    document.addEventListener('pointermove', pointerhandler);

    return function () {
      document.removeEventListener('pointerdown', pointerhandler);
      document.removeEventListener('pointermove', pointerhandler);
    };
  }, [page]);

  return (
    <div className="tm-forum-gaimat bg-white pt-[53px]">
      <Navigation />
      <main className="bg-white relative overflow-hidden">
        {content.map((item) => {
          switch (item.component) {
            case 'banner':
              return <Banner as="section" {...item} key={hash(item)} />;
            case 'twoColumn':
              return <TwoColumn as="article" {...item} key={hash(item)} />;
            case 'list':
              return <List {...item} key={hash(item)} />;
            case 'survey':
              return <Survey {...item} key={hash(item)} />;
            case 'typography':
              return <Typography {...item} key={hash(item)} />;
            case 'ctaForm':
              return <CtaForm {...item} key={hash(item)} />;
            case 'resultsBanner':
              return <ResultsBanner {...item} key={hash(item)} />;
            case 'resultsYourResults':
              return <ResultsYourResults {...item} key={hash(item)} />;
            case 'cta':
              return <Cta {...item} key={hash(item)} />;
            case 'resultsPillar':
              return <ResultsPillar {...item} key={hash(item)} />;
          }
        })}
      </main>
      <div id="pdf-mount" className="opacity-0"></div>
    </div>
  );
};

export default App;
